import store from 'store'
import actions from './actions.ts'

const STORED_SETTINGS = (storedSettings) => {
  const settings = {}
  Object.keys(storedSettings).forEach((key) => {
    const item = store.get(`app.settings.${key}`)
    settings[key] = typeof item !== 'undefined' ? item : storedSettings[key]
  })
  return settings
}

const initialState = {
  ...STORED_SETTINGS({
    authProvider: 'landing', // firebase, jwt
    logo: 'OfficeNEXT Safebox',
    locale: 'en-US',
    umkDuration: 10 * 60 * 1000, // 10분 동안 유효.
    umkWarningDuration: 0, // 1 * 60 * 1000, // 만료 1분 전에 경고.
    clipboardClearMs: 0, // 클립보드 자동삭제 유지시간(ms). 0=Never(off). 복사 후 이 시간 경과 시 클립보드 비움.
    isSidebarOpen: false,
    isSupportChatOpen: false,
    isMobileView: false,
    isMobileMenuOpen: false,
    isMenuCollapsed: false,
    menuLayoutType: 'left', // left, top, nomenu
    routerAnimation: 'fadein', // none, slide-fadein-up, slide-fadein-right, fadein, zoom-fadein
    menuColor: 'white', // white, dark, gray
    theme: 'default', // default, dark
    authPagesColor: 'white', // white, gray, image
    primaryColor: '#4b7cf3',
    isMenuUnfixed: false,
    isMenuShadow: false,
    isTopbarFixed: true,
    isGrayTopbar: true,
    isContentMaxWidth: true,
    isAppMaxWidth: false,
    isGrayBackground: true,
    isCardShadow: true,
    isSquaredBorders: false,
    isBorderless: false,
    recoverKeyEnabled: null,
    recoveryOption: 'NONE', // PR1: 복구 정책(NONE/LOCAL/ESCROW) — register UI 선택값(transient)
    isGrid: false,
    isSendNotification: false,
    showZeroDarkWeb: true,
    isLeaked: false,
  }),
}

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
